// src/pages/NotFound.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { FiHome } from 'react-icons/fi';

const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 px-4">
      <div className="text-center animate-fadeIn">
        <h1 className="text-[120px] md:text-[160px] font-extrabold text-primary-600 drop-shadow-sm">
          404
        </h1>

        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-4 mb-4">
          Page introuvable
        </h2>

        <p className="text-gray-600 mb-8 max-w-md mx-auto">
          Oups... La page que vous cherchez n’existe pas ou a été déplacée.
        </p>

        <Link
          to="/"
          className="inline-flex items-center space-x-2 bg-primary-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-primary-700 shadow transition"
        >
          <FiHome size={20} />
          <span>Retour à l'accueil</span>
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
